import { SchedulerItem } from './item';
import { WorkOrderDetail } from '../../../api/backend/types/work-order-detail';
import { SchedulerWorkOrderOnMachine } from './wo-on-machine';
import { WorkOrderBatch } from '../../../api/elite/types/work-order-batch';
import { SubWorkOrder } from '../../../api/elite/types/sub-work-order';
import { AssemblyItem } from 'src/app/api/elite/types/assembly-item';

export class SchedulerWorkOrder extends SchedulerItem {
  readonly TYPE = 'work_order';
  transactionId: number;
  transactionNumber: string;
  status = false;
  priority = false;

  startDate: Date;
  endDate: Date;
  location: string;
  assemblyDescription: string;

  /**
   * @description
   * id del departamento
   */
  typeId: number;

  /**
   * @deprecated
   */
  workOrderDetail: WorkOrderDetail;
  assemblyItem: AssemblyItem;

  machinesWorkOrders: SchedulerWorkOrderOnMachine[] = [];

  workOrderBatches: WorkOrderBatch[] = [];

  subWorkOrders: SubWorkOrder[] = [];

  isClosedInNS = false;
  onSchedule = true;

  specialInstructions: string;

  quantityPlanned = 0;

  get id(): number {
    return this.transactionId;
  }

  get itemsOnMachine(): SchedulerWorkOrderOnMachine[] {
    return this.machinesWorkOrders;
  }
  set itemsOnMachine(value: SchedulerWorkOrderOnMachine[]) {
    this.machinesWorkOrders = value;
  }
  get title(): string {
    return this.transactionNumber;
  }

  get workOrderId(): number {
    return this.transactionId;
  }

  static fromObject(object: SchedulerItem): SchedulerWorkOrder {
    const workOrder = new SchedulerWorkOrder();
    Object.assign(workOrder, object);
    return workOrder;
  }

  getItemOnMachineByMachineId(machineId: number): SchedulerWorkOrderOnMachine {
    return this.machinesWorkOrders.find((item) => item.machineId === machineId);
  }

  factoryItemOnMachine(
    woOnMachine: SchedulerWorkOrderOnMachine
  ): SchedulerWorkOrderOnMachine {
    const itemOnMachineClass = new SchedulerWorkOrderOnMachine();
    Object.assign(itemOnMachineClass, woOnMachine);
    this.itemsOnMachine = [...this.itemsOnMachine, itemOnMachineClass];
    return woOnMachine;
  }
}
